<template>
    <el-dialog :title="title"
               :visible="showDialog"
               @open="handleOpen"
               @close="clickClose"
               width="60%">
        <div class="table-responsive" v-loading="loading">
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th style="white-space: nowrap;">Fecha y hora</th>
                        <th>Estado</th>
                        <th style="white-space: nowrap;">Código</th>
                        <th>Incidencia</th>
                        <th>Usuario</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in records" :key="index">
                        <td>{{ row.date }}</td>
                        <td>{{ row.state }}</td>
                        <td>{{ row.code }}</td>
                        <td>
                            <div>{{ row.description }}</div>
                            <ul class="mb-0 pl-3" v-if="row.notes.length">
                                <li v-for="(note, i) in row.notes" :key="i">{{ note }}</li>
                            </ul>
                        </td>
                        <td>{{ row.user_name }}</td>
                    </tr>
                    <tr v-if="!records.length && !loading">
                        <td colspan="5" class="text-center">No hay incidencias registradas</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <span slot="footer">
            <el-button @click.prevent="clickClose">Cerrar</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['showDialog', 'documentId'],

    data() {
        return {
            title: 'Registro de Incidencias',
            resource: 'documents',
            records: [],
            loading: false,
        }
    },
    methods: {
        async handleOpen() {
            this.records = []
            this.title = 'Registro de Incidencias'
            this.loading = true

            await this.$http.get(`/${this.resource}/incidences/${this.documentId}`)
                .then(response => {
                    if (response.data.success) {
                        this.records = response.data.data
                        this.title = `Registro de Incidencias (${response.data.number})`
                    }
                })
                .catch(() => {
                    this.$message.error('No se pudo obtener el registro de incidencias')
                })

            this.loading = false
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/documents/partials/incidence.vue